import api from '../../plugins/api';

const getDealHistory = (params) => {
  return api.get('/api/crm/deals/getDealHistory', params);
};

export default getDealHistory;
